var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.offline)?_c('div',{staticClass:"offlineMessage"},[_vm._v(" You are offline. Any changes you make will be effective when you go back online. ")]):_vm._e(),_c('localization'),_c('update-notification'),_c('late-attendance-notification')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }